/**
 * Flatten a multiple dimension array recursively
 * @param  {array}  arr   array to flatten
 * @param  {number} limit depth to limit the flattening
 * @param  {number} count counter for limiting
 * @return {array}        the flattened array
 */
export default function flatten(arr, limit = undefined, count = 0) {
  return arr.reduce((acc, item) => {
    if (Array.isArray(item) && !(undefined !== limit && limit !== count)) {
      return acc.concat(flatten(item, limit, count + 1));
    }
    return acc.concat(item);
  }, []);
}



// WEBPACK FOOTER //
// ./app/utils/array/flatten.js